import { lazy, Suspense, useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";

const ChatBot = lazy(() => import("./ChatBot"));

/**
 * Defers loading of the ChatBot bundle (framer-motion + react-markdown)
 * until the browser is idle or the user clicks the launcher. Improves
 * initial mobile performance significantly.
 */
const ChatBotLoader = () => {
  const [load, setLoad] = useState(false);

  useEffect(() => {
    const w = window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number };
    const idle = w.requestIdleCallback ?? ((cb: () => void) => window.setTimeout(cb, 2500));
    const id = idle(() => setLoad(true), { timeout: 4000 });
    return () => {
      const cancel = (window as Window & { cancelIdleCallback?: (id: number) => void }).cancelIdleCallback;
      if (cancel) cancel(id as number);
      else window.clearTimeout(id as number);
    };
  }, []);

  if (load) {
    return (
      <Suspense fallback={null}>
        <ChatBot />
      </Suspense>
    );
  }

  return (
    <button
      onClick={() => setLoad(true)}
      aria-label="Abrir chat"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-lg flex items-center justify-center hover:bg-primary/90 transition-colors"
    >
      <MessageCircle size={26} aria-hidden="true" />
    </button>
  );
};

export default ChatBotLoader;
